var logoTiktok = "https://shopfront-cdn.tekoapis.com/static/28e4a3a78ca94c96.svg";

export { logoTiktok as default };
